'use client';

import { BetterTooltip } from './tooltip';

import { cn } from '@/lib/utils';

type PillProps = {
  text: string;
  tooltipText?: string; // Make tooltipText optional
  className?: string; // Allow custom styling
};

export function Pill({ text, tooltipText, className }: PillProps) {
  const pillContent = (
    <span
      className={cn(
        'inline-flex items-center rounded-md bg-zinc-800/80 px-2 py-1 text-xs font-medium text-zinc-300 whitespace-nowrap',
        // A pill with a tooltip has to take the pointer to open it; others pass it through.
        !tooltipText && 'pointer-events-none',
        className,
      )}
    >
      {text}
    </span>
  );

  if (tooltipText) {
    return <BetterTooltip content={tooltipText}>{pillContent}</BetterTooltip>;
  }

  return pillContent;
}
